import { ThemeProvider, ToastProvider } from '@zyxantech/tux'
import { AuthBootstrap } from '@/components/auth/AuthBootstrap'
import { AppRouter } from '@/router'
import { useUiStore } from '@/store/ui.store'

/**
 * Application root. ThemeProvider is driven (controlled) by the UI store so theme
 * changes flow through one source of truth and tux applies `data-theme` to <html>.
 * AuthBootstrap performs silent re-auth before the router renders.
 */
export function App() {
  const theme = useUiStore((state) => state.theme)

  return (
    <ThemeProvider theme={theme}>
      <ToastProvider>
        <AuthBootstrap>
          <AppRouter />
        </AuthBootstrap>
      </ToastProvider>
    </ThemeProvider>
  )
}
